<script>
  import { Link } from "svelte-routing";
  import { _ } from '../services/i18n';
</script>

<div id="container" class="fadeIn def_back about-us">
  <h2 class="titles">{$_('menu.sezChiSiamo')}</h2>
  <div>
    <ul id="whoare-list">
      <li id="models3d"> <!-- 3D Models -->
        <h3 class="whoare-title">
          {$_('contacts.whoModelsTitle')}
        </h3>
        <Link to="/gallery-models">
          <span class="whoare-img"></span>
          <span class="whoare-span" >
            {@html $_('contacts.whoModelsDesc')}
          </span>
        </Link>
      </li>
      <li id="webSites"> <!-- Web Sites -->
        <h3 class="whoare-title">
          {$_('menu.sezWebsites')}
        </h3>
        <Link to="/gallery-websites">
          <span class="whoare-img"></span>
          <span class="whoare-span">
            {@html $_('contacts.whoWebsitesDesc')}
          </span>
        </Link>
      </li>
      <li id="graphics"> <!-- Graphics -->
        <h3 class="whoare-title">
          {$_('menu.sezGraphics')}
        </h3>
        <Link to="/gallery-graphics">
          <span class="whoare-img"></span>
          <span class="whoare-span">
            {@html $_('contacts.whoGraphicsDesc')}
          </span>
        </Link>
      </li>
      <li id="tools"> <!-- Tools -->
        <h3 class="whoare-title">
          {$_('menu.sezTools')}
        </h3>
        <Link to="/gallery-tools">
          <span class="whoare-img"></span>
          <span class="whoare-span">
            {@html $_('contacts.whoToolsDesc')}
          </span>
        </Link>
      </li>
    </ul>
  </div>
</div>

<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

#container.about-us {
  max-width: 1024px;
  #whoare-list {
    list-style: none;
    margin: 25px auto 50px;
    text-align: center;
    li {
      display: inline-block;
      position: relative;
      margin: 10px 12px 20px;
      background-color: #000;
    }
    li, .whoare-img, .whoare-span {
      width: 320px;
      height: 300px;
      @include box-shadow(0 0 0px 10px transparentize(#000, 0.8) inset);
      @include border-radius(16% 4%);
    }
    li:nth-child(2), li:nth-child(3) {
      @include border-radius(4% 16%);
      .whoare-img, .whoare-span {
        @include border-radius(4% 16%);
      }
    }

    li:hover .whoare-span {
      opacity: 1;
    }
    .whoare-img {
      display: block;
      -ms-interpolation-mode: bicubic;
      background-image: url("https://tools.obyte.it/img/idrobyte/chiSiamo.png");
      background-repeat: no-repeat;
    }

    li {
      &#models3d .whoare-img {
        background-position: -1px -1px;
        background-color: #0b0a0c;
      }
      &#webSites .whoare-img {
        background-position: -323px -1px;
        background-color: #142230;
      }
      &#graphics .whoare-img {
        background-position: -1px -303px;
        background-color: #420606;
      }
      &#tools .whoare-img {
        background-position: -323px -303px;
        background-color: #dee9fa;
      }
    }
    @media #{$tablet-m} {
      width:100%;
      li {
        margin: 2px auto 0;
      }
    }
    @media #{$mobile} {
      li {
        float:none;
      }
    }
  }
  .whoare-title {
    z-index: 2;
    text-transform: capitalize;
    font-family: $idro-font-family-title;
    letter-spacing: 1px;
    color: #7abaa8;
    line-height: 100%;
    font-size: 20px;
    position: absolute;
    left: 50px;
    top: 13px;
    text-shadow: 1px 1px 2px #101010;
  }
  .whoare-span {
    font-size: $font-size-s;
    box-sizing: border-box;
    opacity: 0;
    @include transition(opacity 0.5s ease-in-out);
    position: absolute;
    left: 0;
    top: 0;
    color: #ffffff;
    font-weight: bolder;
    background-image: url("https://tools.obyte.it/img/idrobyte/sfondoChiSiamo.png");
    line-height: 180%;
    text-align: justify;
    padding: 42px 15px 0;
    &:active {
      color: #b1c1e4
    }
    @media #{$mobile} {
      opacity: 0.7 !important;
    }
  }
}
</style>
